<template>
  <div>
    <address-modal
      v-if="isPowerUserOrAdministrator"
      :show="showAddressModal"
      :current-operation="currentOperation"
      :address="address"
      :linked-entity-id="linkedEntityId"
      :type="type"
      @close="closeAddressModal"
    />

    <p>
      Liste des adresses
      <button
        v-show="!editingDisabled"
        id="btn-add"
        type="button"
        class="btn btn-icon btn-round btn-success"
        aria-label="Ajouter une addresse"
        @click="createAddress"
      >
        <i class="fa fa-plus" />
      </button>
    </p>
    <div class="row text-left">
      <div v-for="(address, index) in addresses" :key="index" class="col-md-6">
        <div
          :class="{ 'clickable-element': !editingDisabled }"
          class="address-card"
          @click="addressCardClicked(address, $event)"
        >
          <b
            >{{ address.id.addrAddrtypeId }} (Défaut :
            {{ address.addrDefault ? 'oui' : 'non' }})</b
          ><br />
          <span v-if="type === personType"
            >Type : {{ address.addrTypeId }}<br
          /></span>
          {{ address.addrStreet }}<br />
          {{ address.addrPostalno }} {{ address.addrCity }}<br />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { isPowerUserOrAdministrator } from '@/services/AuthService';
import AddressModal from 'src/components/ApplicationViews/Modals/AddressModal.vue';

export default {
  name: 'AddressesCards',
  components: {
    AddressModal,
  },
  props: {
    addresses: Array,
    editingDisabled: Boolean,
    type: String,
    linkedEntityId: Number,
    fetch: Function,
  },
  data() {
    return {
      showAddressModal: false,
      currentOperation: null,
      address: {
        addrCantonCode: null,
      },
      personType: 'people',
    };
  },
  computed: {
    isPowerUserOrAdministrator,
  },
  methods: {
    addressCardClicked(address, event) {
      if (this.editingDisabled) {
        event.stopPropagation();
      } else {
        this.currentOperation = 'edit';
        Object.assign(this.address, address);
        this.showAddressModal = true;
      }
    },
    createAddress() {
      this.currentOperation = 'create';
      this.address = {};
      this.showAddressModal = true;
    },
    closeAddressModal() {
      this.showAddressModal = false;
      this.fetch(this.linkedEntityId);
    },
  },
};
</script>

<style scoped>
.address-card {
  background-color: lightgreen;
  padding: 15px;
  border: none;
  border-radius: 5px;
  margin-bottom: 10px;
  margin: 5px;
}
</style>
